export const FINANCIAL_SITUATION_FIELD_NAME = 'Your financial situation';
export const MONTHLY_INCOME_FIELD_NAME = 'Average monthly income';
export const MONTHLY_PAYMENT_FIELD_NAME = 'Average amount of monthly payment';
export const DEBT_INFO_QA_LABEL = 'debtInfo';
